export default __webpack_public_path__ + "static/media/inventory.1e1a7400.PNG";